import { ExternalLink, Radio, ShieldCheck } from 'lucide-react';
import { Button } from '@/components/ui/Button';
import { Modal } from '@/components/ui/Modal';

export interface ProcessoChatPreviewItem {
  id: number;
  titulo: string;
  orgao?: string | null;
  link?: string | null;
  fonte?: string | null;
}

export function ProcessoChatPreview({ item, onClose }: { item: ProcessoChatPreviewItem | null; onClose: () => void }) {
  if (!item) return null;

  return (
    <Modal isOpen onClose={onClose} title="Chat do processo">
      <div className="space-y-4">
        <div className="rounded-lg border border-ds-border bg-ds-surface2 p-3">
          <p className="text-sm font-semibold text-ds-text-primary">{item.titulo}</p>
          {item.orgao && <p className="mt-1 text-xs text-ds-text-secondary">{item.orgao}</p>}
          <p className="mt-1 text-xs text-ds-text-secondary">Canal oficial da licitação • {item.fonte || 'Origem não informada'}</p>
        </div>

        <div className="rounded-lg border border-ds-warning/30 bg-ds-warning/10 p-3" role="status">
          <div className="flex gap-2">
            <ShieldCheck className="mt-0.5 h-4 w-4 shrink-0 text-ds-warning" />
            <div>
              <p className="text-sm font-semibold text-ds-text-primary">Monitoramento não conectado</p>
              <p className="mt-1 text-sm text-ds-text-secondary">Ainda não há integração autorizada para importar mensagens deste portal. Até a conexão ser ativada, acompanhe o chat diretamente no portal oficial.</p>
            </div>
          </div>
        </div>

        <div className="space-y-3 rounded-lg border border-ds-border p-4" aria-label="Contexto do chat">
          <div className="flex gap-3">
            <div className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-ds-brand-subtle/30"><Radio className="h-4 w-4 text-ds-brand" /></div>
            <div>
              <p className="text-sm font-medium text-ds-text-primary">Radar da AlpendreInfra</p>
              <p className="mt-1 text-sm text-ds-text-secondary">Quando a integração estiver conectada, mensagens, retificações e prazos poderão aparecer aqui com contexto e ação recomendada.</p>
            </div>
          </div>
          <div className="border-l-2 border-ds-border py-1 pl-4 text-sm text-ds-text-secondary">Nenhuma comunicação foi importada para esta licitação.</div>
        </div>

        <div className="flex flex-wrap justify-end gap-2">
          <Button size="sm" variant="secondary" onClick={onClose}>Fechar</Button>
          {item.link && <a href={item.link} target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center gap-2 rounded-lg bg-ds-brand-solid px-3 py-1.5 text-sm font-medium text-ds-on-brand hover:brightness-110 focus:outline-none focus:ring-2 focus:ring-ds-brand"><ExternalLink className="h-4 w-4" />Abrir portal oficial</a>}
        </div>
      </div>
    </Modal>
  );
}
